module.exports = __webpack_public_path__ + "img/Errol_Icon.0cec11c2.png";